import React, { useState } from 'react';
import { DataColumn, LinkColumn, List } from 'components/lists';
import { renderTime, weekDays } from 'utils/dayTimeHelpers';
import { IikoUsageForm } from './iikoUsageForm';

export const IikoDiscountUsages = ({ dayTimeUsages, onSave, onDelete }) => {
  const [selected, setSelected] = useState(null);
  const [modalIsVisible, setModalIsVisible] = useState(false);

  return (
    <>
      <div className="-mt-8">
        <List
          source={dayTimeUsages || []}
          onRowClick={(item) => {
            setSelected(item);
            setModalIsVisible(true);
          }}
          keyField="usage_id"
        >
          <DataColumn
            name="Day"
            dbColumnName="day"
            render={(item) => {
              return weekDays.find((x) => x.value === item.day)?.label || item.day;
            }}
            headerClass="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 table-cell"
            dataCellClass="whitespace-nowrap px-3 py-4 text-sm text-gray-500 table-cell"
          />
          <DataColumn
            name="From"
            dbColumnName="from"
            render={(item) => {
              return renderTime(item.from_hour, item.from_minute);
            }}
            headerClass="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 table-cell"
            dataCellClass="whitespace-nowrap px-3 py-4 text-sm text-gray-500 table-cell"
          />
          <DataColumn
            name="Until"
            dbColumnName="until"
            render={(item) => {
              return renderTime(item.to_hour, item.to_minute);
            }}
            headerClass="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 table-cell"
            dataCellClass="whitespace-nowrap px-3 py-4 text-sm text-gray-500 table-cell"
          />
          <LinkColumn
            title="Delete"
            onClick={onDelete}
            className="relative py-3.5 pl-3 sm:pr-6"
            dataCellClass="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6"
          />
        </List>
      </div>
      <IikoUsageForm
        itemData={selected}
        isOpen={modalIsVisible}
        closeModal={() => setModalIsVisible(false)}
        onSave={(data) => {
          onSave(data);
          setModalIsVisible(false);
        }}
      />
      <div className="text-right mt-6">
        <button
          type="button"
          onClick={() => {
            setSelected(null);
            setModalIsVisible(true);
          }}
          className="bg-indigo-600 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Add new
        </button>
      </div>
    </>
  );
};
